// wechat.js
 
var jweixin = require('jweixin-module');
 
export default {
 
	//初始化sdk配置  
	initJssdk: function(callback) {
		uni.request({
			url: '请求的url',
			data: {
				wx_url: window.location.href.split('#')[0]
			},
			success: res => {
				if (res.data) {
					jweixin.config({
						debug: false, // 开启调试模式
						appId: res.data.d.appId, // 必填，公众号的唯一标识
						timestamp: res.data.d.timestamp, // 必填，生成签名的时间戳
						nonceStr: res.data.d.nonceStr, // 必填，生成签名的随机串
						signature: res.data.d.signature, // 必填，签名
						jsApiList: [
							'checkJsApi',
							'updateAppMessageShareData', //朋友
							'updateTimelineShareData' //朋友圈
 
						] ,// 必填，需要使用的JS接口列表
						openTagList:[
							"wx-open-launch-weapp"
						] // 打开小程序
					});
					// 配置完成后，再执行分享等功能  
					// _this.hasInit = true;
					if (callback) {
						callback(res.data);
					}
 
				}
			}
		});
 
	}
}


// WEBPACK FOOTER //
// ./src/common/wechat.js